import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const planIncrementRoute: InvariantJiraRoute = {
	name: 'software-plan-increment',
	path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId',
	exact: true,
};
